import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';
import { UserColors } from '../../types/userColor.types';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataType: IDataType.string,
    dataField: 'userName',
    width: '10%',
    caption: 'User',
  },
  {
    dataType: IDataType.string,
    dataField: 'color',
    width: '78%',
    caption: 'Color',
    cellRender: (row) => {
      const colorNames = UserColors.filter((x) => x.value === row.data.color);
      if (!colorNames || colorNames.length === 0) return <></>;
      return (
        <div style={{ color: `#${row.data.color}` }}>
          {translate!(colorNames[0].name, 'UserColor.Color')}
        </div>
      );
    },
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={() => handleEdit(cellData)}
    />
  );
};
